import Recaptcha from 'react-google-recaptcha'
import React, { Component, Fragment } from 'react'
import { x } from '@xstyled/styled-components'
import Helmet from 'react-helmet'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { initialise, submitFeedback, updateForm } from '../../store/feedback'
import { staticPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'

const recaptchaRef = React.createRef()

export class Feedback extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
    props.staticPageView(props.location.pathname, props.visitorId, props.sessionId)
    setPageType('section')
  }
  componentDidMount () {
    this.props.initialise()
  }
  handleChange (event) {
    let newState = {}
    newState[event.target.name] = event.target.value
    this.props.updateForm(newState)
  }
  validateEmail (email) {
    var re = /^[^.@][^@]+@{1}[^@]+\.[^@]+[^.@]$/i
    return email.match(re)
  }
  validateName (name) {
    var re = /^[`a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ' -]{2,45}$/i
    return name.match(re)
  }
  validatePhone (phone) {
    var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/
    return phone.match(re)
  }
  verifyCallback () {
    this.props.updateForm({
      captchaVerified: true,
      recaptchaValue: recaptchaRef.current.getValue()
    })
  }
  handleSubmit (event) {
    event.preventDefault()
    if (!this.validateEmail(this.props.email)) {
      this.props.updateForm({ output: 'Please enter a valid email address' })
      return false
    } else if (!this.validateName(this.props.fullName)) {
      this.props.updateForm({ output: 'Please enter a valid full name' })
      return false
    } else if (!this.validatePhone(this.props.phone)) {
      this.props.updateForm({ output: 'Please enter a valid cellphone number' })
      return false
    } else if (process.env.NODE_ENV === 'production' && !this.props.captchaVerified) {
      this.props.updateForm({ output: 'Please enter a Captcha' })
      return false
    }
    const data = {fullName: this.props.fullName, email: this.props.email, phone: this.props.phone, enquiryType: this.props.enquiryType, message: this.props.message, recaptchaValue: this.props.recaptchaValue}
    this.props.submitFeedback(data)
    return true
  }

  render () {
    if (!this.props.isSubmitting && !this.props.hasSubmitted) {
      return (
        <>
          <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%'>
            <Helmet title='Feedback, Enquiries and Comments | IOL' />
            <x.div w='100%' maxWidth={1220} mx='auto' mt={50} mb={30}>
              <x.h1 text='h1' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Feedback Form</x.h1>
              <x.p text='small' mb={15}>Fill out the form below to send your comments, queries and feedback.</x.p>
              <x.form maxWidth={550} id='item-form' name='item-form' display='flex' flexDirection='column' encType='text/plain' onSubmit={this.handleSubmit}>
                <x.label text='medium' htmlFor='fullName' mb={15}>Full Name:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='fullName' placeholder='Type your full name' required='required' type='text' name='fullName' value={this.props.fullName} onChange={this.handleChange} />
                <x.label text='medium' mb={15} htmlFor='email'>Email:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='email' placeholder='example@domain.com' required='required' type='email' name='email' value={this.props.email} onChange={this.handleChange} />
                <x.label text='medium' mb={15} htmlFor='phone'>Cellphone:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='phone' placeholder='Type your cellphone number' required='required' type='text' name='phone' value={this.props.phone} onChange={this.handleChange} />
                <x.label text='medium' mb={15} htmlFor='enquiryType'>Enquiry:</x.label>
                <x.select mb={15} bg='ltGrey' p={10} text='medium' id='enquiryType' name='enquiryType' onChange={this.handleChange}>
                  <option value='general'>General Enquiry</option>
                  <option value='technical'>Technical Issue</option>
                  <option value='news'>News</option>
                  <option value='business'>Business</option>
                  <option value='sport'>Sport</option>
                  <option value='motoring'>Motoring</option>
                  <option value='lifestyle'>Lifestyle</option>
                  <option value='travel'>Travel</option>
                  <option value='entertainment'>Entertainment</option>
                  <option value='newspapers'>Newspapers</option>
                  <option value='press'>Press Release</option>
                </x.select>
                <x.label text='medium' mb={15} htmlFor='message'>Message:</x.label>
                <x.textarea mb={15} bg='ltGrey' p={10} text='medium' name='message' id='message' rows='6' onChange={this.handleChange} />
                <Recaptcha ref={recaptchaRef} sitekey={process.env.RAZZLE_GOOGLE_CAPTCHA_SITE_KEY} onChange={this.verifyCallback} />
                {this.props.output && (
                  <p>{this.props.output}</p>
                )}
                <x.input mt={15} mb={15} bg='red' p={10} text='medium' color='white' textTransform='uppercase' fontWeight='medium' w={150} id='submitbutton' type='submit' value='Submit' className='btn btn-red btn-anim' />
                <x.input type='hidden' name='form_hash' value='n1opdyilO0bEvwBq' id='form_hash' />
              </x.form>
            </x.div>
          </x.main>
        </>
      )
    } else if (this.props.isSubmitting) {
      return (
        <>
          <Helmet title='Article' />
          <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%'>
            <x.div w='100%' maxWidth={1220} mx='auto' mt={50} mb={30}>
              <x.p w='100%' maxWidth={1220} mx='auto' text='large'mt={50} mb={30}>Submitting your feedback ...</x.p>
            </x.div>
          </x.main>
        </>
      )
    } else if (this.props.hasSubmitted) {
      return (
        <>
          <Helmet title='Thank you for your feedback' />
          <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%'>
            <x.div w='100%' maxWidth={1220} mx='auto' mt={50} mb={30}>
              <x.h1 text='h1' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Thank you for your feedback</x.h1>
              <x.p w='100%' maxWidth={1220} mx='auto' text='large' mt={50} mb={30}>Thank you for your feedback. We will get back to you shortly.</x.p>
            </x.div>
          </x.main>
        </>
      )
    }
  }
}

const mapStateToProps = (state) => ({ ...state.feedback, visitorId: getVisitorId(state), sessionId: getSessionId(state) })
const mapDispatchToProps = (dispatch) => bindActionCreators({ initialise, submitFeedback, updateForm, staticPageView }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Feedback)
